// extracted by mini-css-extract-plugin
module.exports = {"emailFormBox":"emailFormBox___28E5W","emailItemBox":"emailItemBox___AgbYk","deleteIcon":"deleteIcon___1U29j","emailAddBtn":"emailAddBtn___2fB6J"};